var _defs, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.7,
    height: 60.57,
    viewBox: "0 0 97.7 60.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#b0b4be;}.a{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.38,0a3.378,3.378,0,0,0-3.37,3.37V43.83a3.384,3.384,0,0,0,3.37,3.37h8.43V57.32c0,1.86.63,3.25,2.5,3.25.82,0,1.3-.58,1.91-1.12L66.73,46.98l27.6.22a3.378,3.378,0,0,0,3.37-3.37V3.37A3.378,3.378,0,0,0,94.33,0ZM51.61,57.58V48.49c-.01-2.3.24-4.17-1.93-4.17H42.31a2.456,2.456,0,0,1-2.44-2.47V5.07A2.456,2.456,0,0,1,42.31,2.6H92.39a2.456,2.456,0,0,1,2.44,2.47V41.85a2.456,2.456,0,0,1-2.44,2.47H67.36a3.766,3.766,0,0,0-2.59,1.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.1,32.88H19.2a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h9.9a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,29.1,32.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.66,26.23v-9.9a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v9.9a1.4,1.4,0,0,1-1.4,1.4h0A1.391,1.391,0,0,1,66.66,26.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.1,21.87H8.93a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4H29.1a1.4,1.4,0,0,1,1.4,1.4h0A1.411,1.411,0,0,1,29.1,21.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.1,10.86H1.4A1.4,1.4,0,0,1,0,9.46H0a1.4,1.4,0,0,1,1.4-1.4H29.1a1.4,1.4,0,0,1,1.4,1.4h0A1.411,1.411,0,0,1,29.1,10.86Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "translate(66.66 28.89)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRequest);
export default __webpack_public_path__ + "static/media/empty_request.93bfa4e738f4f34813888607d7baa6e5.svg";
export { ForwardRef as ReactComponent };